import { chakra } from '@chakra-ui/react'

import { TranscriptError } from 'src/models/Error'

export const Wrapper = chakra('div', {
    baseStyle: ({ theme }) => ({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.transcript.appBackgroundColors[theme.appBackgroundColorIndex].colorValue,
        color: theme.palette.transcript.textColors[0].colorValue,
    }),
})

export const Text = chakra('div', {
    baseStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginTop: '16px',
        maxWidth: '400px',
        padding: '0 10px',
        [`&.${TranscriptError.INVALID_TOKEN}`]: {
            maxWidth: '500px',
        },
    },
})

export const Title = chakra('h1', {
    baseStyle: {
        fontSize: '32px',
        lineHeight: 1.5,
    },
})

export const Description = chakra('span', {
    baseStyle: {
        fontSize: '16px',
        lineHeight: 1.5,
    },
})
